<template lang="pug">
  div.wrap-header
    div.header-content.f.fm
      div(v-if="$route.name == 'post'").content.f.fm.flex-between
        div.wrap-back
          v-icon(@click="onBack") arrow_back_ios
        div.wrap-tweet
          span(@click="tweet").px10.py8 ツイート
      div(v-else).content.f.fm.flex-between
        // span(@click="$router.push('/avatar/minna_ai')") X号
        div(@click="$router.push('/avatar/minna_ai')").wrap-avatar-icon.f.fh
          img(src="/img/avatar-main.png")
        div.f.fm
          a(href="https://twitter.com/minna_ai" target="brank").wrap-icon.mr8.f.fh
            img(src="/img/icon/logo-twitter.svg")
          a(href="https://www.youtube.com/channel/UCcI7JI3PI79DKaQ8Zeyrdjg" target="brank").wrap-icon.mr8.f.fh
            img(src="/img/icon/logo-youtube.svg")
          span(v-if="uid && !isAnonymous" @click="$router.push(`/user/${uid}`)").label マイページ
          span(v-if="uid && isAnonymous" @click="$router.push(`/sign-in`)").label サインイン

</template>

<style lang="scss" scoped>
.wrap-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 48px;
  z-index: 1000;
  background: #f8f8f8;
  border-bottom: solid 0.6px rgba(0, 0, 0, 0.2);
  .header-content {
    position: relative;
    width: 92%;
    max-width: 620px;
    height: 100%;
    margin: 0 auto;
    .content {
      width: 100%;
      .wrap-tweet {
        span {
          border-radius: 8px;
          background: #ff9999;
          color: #fff;
          font-weight: bold;
          font-size: 12px;
          cursor: pointer;
        }
      }
      .wrap-icon {
        width: 22px;
        width: 22px;
        img {
        }
      }
      .wrap-avatar-icon {
        width: 24px;
        height: 24px;
        overflow: hidden;
        border: solid 1px rgba(0, 0, 0, 0.2);
        border-radius: 50%;
      }
      .label {
        color: #ff9999;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
}
</style>

<script>
import Auth from '@/components/auth'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
const { mapActions: mapActionsPost } = createNamespacedHelpers('post')

export default {
  components: {
    Auth
  },
  computed: {
    ...mapStateAuth([
      'uid',
      'isAnonymous'
    ])
  },
  props: {

  },
  data () {
    return {

    }
  },
  async created () {

  },
  methods: {
    ...mapActionsPost([
      'setTweetToRetweet'
    ]),
    tweet () {
      this.$emit('tweetPost')
    },
    onBack () {
      this.setTweetToRetweet(null)
      this.$router.go(-1)
    }
  }
}
</script>
